import { Menu } from 'antd';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useLocation } from 'react-router-dom';
import { useMedia } from '../../../hooks';
import configProxy from '../../../utils/config';
import SideDrawer from '../../navigation/side-drawer/side-drawer';
import { renderSidebar } from './render-sidebar-items';

const TASideBar = ({ header, selected, menuItems, visible, close, collapseOnRouteChange }: any) => {
	let [collapsed, setCollapsed] = useState(true);
	let media = configProxy.defaultExpandScreenSize;
	const routeListner = () => {
		if (collapseOnRouteChange) close();
	};

	useEffect(() => {
		routeListner();
	}, [useLocation().pathname]);

	let desktopView = useMedia(media);

	const collapseHandler = collapseState => {
		setCollapsed(collapseState);
	};

	let headerComp = header ? (typeof header === 'function' ? header(collapsed, visible) : header) : null;
	let sidebar = (
		<SideDrawer
			visible={visible}
			onClose={close}
			collapsable={desktopView}
			onCollapse={collapseHandler}
			collapsed={desktopView && collapsed}
			media={media}
		>
			{headerComp}

			<Menu
				selectedKeys={[selected]}
				inlineCollapsed={desktopView && collapsed}
				mode="inline"
				theme="dark"
				className="dashboard-sidebar"
			>
				{renderSidebar(menuItems, '/dashboard', collapsed)}
			</Menu>
		</SideDrawer>
	);
	return desktopView ? sidebar : ReactDOM.createPortal(sidebar, document.getElementById('root')!);
};
export default TASideBar;
